var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-template",
    [
      _c(
        "v-row",
        {
          staticClass: "py-0 main-row",
          attrs: {
            "justify-sm": "center",
            "justify-md": "center",
            "justify-lg": "center",
            "justify-xl": "center",
          },
        },
        [
          _c(
            "v-col",
            {
              class: { "mt-4": _vm.notXs, "pl-10": _vm.xs },
              attrs: { cols: "11", xl: "11", lg: "11", md: "11", sm: "11" },
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "auto" } }, [
                            _c("img", {
                              staticClass: "arrow px-4 py-3",
                              attrs: { src: _vm.ic_back, id: "back-btn" },
                              on: { click: _vm.backToShipments },
                            }),
                          ]),
                          _c(
                            "v-col",
                            { staticClass: "ml-n4", attrs: { cols: "auto" } },
                            [
                              _c("label", { staticClass: "back-lbl" }, [
                                _vm._v("Back to Shipments "),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-n6" },
                        [
                          _c("v-col", { attrs: { cols: "auto" } }, [
                            _c("img", {
                              staticClass: "arrow px-4 py-3 hidden-el",
                              attrs: { src: _vm.ic_back },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      attrs: { xl: "7", lg: "9", md: "10", sm: "12", xs: "12" },
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c("v-col", { attrs: { cols: "auto" } }, [
                            _c("label", { staticClass: "section-header" }, [
                              _vm._v("Shipment Tracking"),
                            ]),
                          ]),
                          _c("v-spacer"),
                          _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("smart-btn", {
                                staticClass: "fr mt-4",
                                class: {
                                  "w-100-pct mt-4": _vm.smAndDown,
                                },
                                attrs: {
                                  label: "Print",
                                  type: "primary",
                                  icon: _vm.ic_print_white,
                                },
                                on: { click: _vm.print },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "tabs-group" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "edi-tab",
                              class: { active: _vm.currentTab == "Status" },
                              attrs: { cols: "auto" },
                              on: {
                                click: function ($event) {
                                  _vm.currentTab = "Status"
                                },
                              },
                            },
                            [_c("label", [_vm._v("Shipment Status")])]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "edi-tab",
                              class: { active: _vm.currentTab == "History" },
                              attrs: { cols: "auto" },
                              on: {
                                click: function ($event) {
                                  _vm.currentTab = "History"
                                },
                              },
                            },
                            [_c("label", [_vm._v("Detail History")])]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "px-0 mt-6" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "px-0", attrs: { cols: "12" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "content-card",
                                  attrs: { elevation: "0" },
                                },
                                [
                                  _vm.currentTab == "Status"
                                    ? _c("shipment-status", {
                                        attrs: { shipment: _vm.shipment },
                                        on: {
                                          copyToClipboard: _vm.copyToClipboard,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.currentTab == "History"
                                    ? _c("detail-history", {
                                        attrs: { shipment: _vm.shipment },
                                        on: {
                                          copyToClipboard: _vm.copyToClipboard,
                                          "no-tracking-url": _vm.noTrackingUrl,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "VueHtml2pdf",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  ref: "html2Pdf",
                  attrs: {
                    "show-layout": false,
                    "float-layout": true,
                    "enable-download": false,
                    "preview-modal": true,
                    "paginate-elements-by-height": 1400,
                    filename: _vm.fileName,
                    "pdf-quality": 2,
                    "manual-pagination": false,
                    "pdf-format": "a4",
                    "pdf-orientation": "p",
                    "pdf-content-width": "100%",
                  },
                },
                [
                  _c(
                    "section",
                    { attrs: { slot: "pdf-content" }, slot: "pdf-content" },
                    [
                      _c("shipment-status-print", {
                        attrs: { printable: true, shipment: _vm.shipment },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: {
            value: _vm.showLoadingScreen,
            opacity: "0.9",
            color: "#fff",
          },
        },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v(" " + _vm._s(_vm.loadingScreenMessage) + " "),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }